import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { firstValueFrom } from 'rxjs'

import { AuthService } from '../services/auth.service'
import { FlashMessageService } from '../services/flash-message.service'
import { User } from '../interfaces/resources/user.interface'

@Injectable({
  providedIn: 'root'
})
export class TransparencyProfileGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private flashMessageService: FlashMessageService
  ) {}

  async canActivate(): Promise<boolean> {
    const user = await firstValueFrom(this.authService.me()) as User | false
    if (!user) {
      return false
    }

    if (user.role?.name !== 'transparencyReportUser') {
      return true
    }

    const profile = user.transparencyReportProfile
    if (profile?.organizationName && profile?.country && profile?.website) {
      return true
    }

    this.flashMessageService.info(
      'Please complete your organization profile before submitting reports.'
    )
    this.router.navigate(['/users/myself'])
    return false
  }
}
